import constants from '#packages/constants';
import type { PapelsMap } from '../aiAssistantTypes';

export const PANELS_MAP: PapelsMap = {
  'site_design.change_theme': {
    panel: constants.ROOT_COMPS.LEFTBAR.DESIGN_PANEL_NAME,
    route: constants.DESIGN_PANEL.VIEWS.THEME,
  },
  'site_design.customize_color_theme': {
    panel: constants.ROOT_COMPS.LEFTBAR.DESIGN_PANEL_NAME,
    route: constants.DESIGN_PANEL.VIEWS.COLOR,
  },
  'site_design.customize_color_theme.advanced_settings': {
    panel: constants.ROOT_COMPS.LEFTBAR.DESIGN_PANEL_NAME,
    route: constants.DESIGN_PANEL.VIEWS.ADVANCED_SETTINGS,
  },
  'site_design.customize_color_theme.change_color_theme': {
    panel: constants.ROOT_COMPS.LEFTBAR.DESIGN_PANEL_NAME,
    route: constants.DESIGN_PANEL.VIEWS.COLOR_THEME,
  },
  'site_design.customize_text_theme': {
    panel: constants.ROOT_COMPS.LEFTBAR.DESIGN_PANEL_NAME,
    route: constants.DESIGN_PANEL.VIEWS.TEXT,
  },
  'site_design.customize_text_theme.customize_heading_styles': {
    panel: constants.ROOT_COMPS.LEFTBAR.DESIGN_PANEL_NAME,
    route: constants.DESIGN_PANEL.VIEWS.TEXT,
    payload: { isCustomizeHeadingStylesOpen: true },
  },
  'site_design.customize_text_theme.customize_paragraph_styles': {
    panel: constants.ROOT_COMPS.LEFTBAR.DESIGN_PANEL_NAME,
    route: constants.DESIGN_PANEL.VIEWS.TEXT,
    payload: { isCustomizeParagraphStylesOpen: true },
  },
  'site_design.customize_text_theme.change_text_theme': {
    panel: constants.ROOT_COMPS.LEFTBAR.DESIGN_PANEL_NAME,
    route: constants.DESIGN_PANEL.VIEWS.TEXT_THEME,
  },
};
